import React from 'react';
import { useActivation } from '@context/MobileOne';
import {
  CardInfobox,
  CardSupport,
  NavigationPageTitle,
  Ta11yText,
  ScrollToTop,
  ButtonCancelActivation
} from '@core/index';
import AppPageContentWrapper from '@part/AppPageContentWrapper';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { appCardStyle, appIconsPath, appInfoCardSize, getKeyByValue } from '@utils/globalConstant';
import { useA11y } from '@context/Utils';
import Icons from '@core/Utils/Icons/Icons';

export function PersonalDataLayout({
  children = null,
  titleKey = '',
  icon = '',
  formTitleKey = ''
}) {
  // Contexts
  const { isLoading, nextStep } = useActivation();
  const { tA11yTranslate } = useA11y();

  // const
  const formTitleContent = tA11y(formTitleKey);
  
  return (
    <>
      <ScrollToTop>
        <div className="min-dvh-100">
          <section className="personal-data-container">
            <div className="personal-data-main-container">
              <AppPageContentWrapper>
                {titleKey && (
                  <div className="w-100 pb-20">
                    <NavigationPageTitle title={titleKey} variant="sm" />
                  </div>
                )}
                <div className="w-100">
                  <CardInfobox
                    cardStyle={appCardStyle.WARNING}
                    cardSize={appInfoCardSize.DEFAULT}
                    cardIcon={appIconsPath.ATTENTION}
                    cardAlt={tA11yTranslate('ek_global_icn_info_aria').content}
                    text="ek_reg_prsnl_data_info_txt1"
                  />
                </div>

                <div className="pt-40">
                  <div className="title-container d-flex align-items-center text-primary">
                    <Icons name={getKeyByValue(appIconsPath,icon)} width={24} height={24} colorType='dark' /> 
                    <Ta11yText
                      tag="h2"
                      textContent={formTitleContent}
                      className="ek-h3 m-0 px-3"
                    />
                  </div>
                </div>
                <div className="form-section">{children}</div>

                <div className="space-40"></div>
                <CardSupport />
                <div className="d-flex justify-content-center mt-32">
                  <ButtonCancelActivation />
                </div>
              </AppPageContentWrapper>
            </div>
          </section>
        </div>
      </ScrollToTop>
    </>
  );
}

export default PersonalDataLayout;
